'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Envelope = require('./Envelope');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Envelope).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Envelope/index.js
// module id = 1176
// module chunks = 1